var _rect, _rect2, _mask, _path, _mask2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRtl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 54,
    viewBox: "0 0 100 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 54,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 53,
    rx: 7.5,
    stroke: "#000624",
    strokeOpacity: 0.2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_472_22802",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 34.5L42.5 27L50 19.5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 27L41.7929 26.2929L41.0858 27L41.7929 27.7071L42.5 27ZM50.7071 33.7929L43.2071 26.2929L41.7929 27.7071L49.2929 35.2071L50.7071 33.7929ZM43.2071 27.7071L50.7071 20.2071L49.2929 18.7929L41.7929 26.2929L43.2071 27.7071Z",
    fill: "#000624",
    fillOpacity: 0.2,
    mask: "url(#path-3-inside-1_472_22802)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_472_22802",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.5 34.5L50 27L57.5 19.5"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 27L49.2929 26.2929L48.5858 27L49.2929 27.7071L50 27ZM58.2071 33.7929L50.7071 26.2929L49.2929 27.7071L56.7929 35.2071L58.2071 33.7929ZM50.7071 27.7071L58.2071 20.2071L56.7929 18.7929L49.2929 26.2929L50.7071 27.7071Z",
    fill: "#000624",
    fillOpacity: 0.2,
    mask: "url(#path-5-inside-2_472_22802)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtl);
export default __webpack_public_path__ + "static/media/rtl.54584409e2b65740941028dd0ddfe4af.svg";
export { ForwardRef as ReactComponent };